package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.VERIFY_MERCHANT_PHONE_VERIFICATION_CODE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class VerifyMerchantPhoneVerificationCodeRequestModel(
    val dialCode: String,
    val phoneNumber: String,
    val verificationCode: String
) : BaseRequestModel(api = VERIFY_MERCHANT_PHONE_VERIFICATION_CODE)
